import { CUSTOM_ELEMENTS_SCHEMA, Component } from '@angular/core';
import { LayoutComponent } from '../../shared/layout/layout.component';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterOutlet } from "@angular/router";
import { TitleUnderlineIconComponent } from '../../shared/icons/title-underline/title-underline.component';

@Component({
  selector: 'app-mfa',
  standalone: true,
  imports: [LayoutComponent, TranslatePipe, RouterOutlet, TitleUnderlineIconComponent],
  templateUrl: './mfa.component.html',
  styleUrl: './mfa.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MfaComponent {
}
